const scrollingPaginationDuration = 300;

export const indexSliderOptions = (instance, options, labels) => {
    return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        cssMode: false,
        autoplay: {
            delay: 4000,
            pauseOnMouseEnter: true
        },
        loop: true,
        autoHeight: true,
        effect: 'fade',
        pagination: {
            el: instance.paginationEl,
            clickable: true,
            hideOnClick: false,
            renderBullet: function (index, className) {
                return '<div class="' + className + '"><div class="swiper-bullet-content">' + '<img class="c-img" src="/img/static/arrowTopIconYellow.svg"/>' + labels[index]  + '</div></div>';
            }
        },
        on: {
            slideChange: function () {
                const $activeBullet = $(instance.paginationEl).find('.swiper-pagination-bullet-active');


                if (window.innerWidth > 768 && $activeBullet.length) {
                    const $paginationEl = $(instance.paginationEl);
                    const bulletOffsetLeft = $activeBullet.offset().left;
                    const parentOffsetLeft = $paginationEl.offset().left;
                    const scrollLeft = $paginationEl.scrollLeft();
                    const bulletWidth = $activeBullet.outerWidth();
                    const parentWidth = $paginationEl.outerWidth();

                    if (bulletOffsetLeft < parentOffsetLeft) {
                        $paginationEl.animate({
                            scrollLeft: scrollLeft - (parentOffsetLeft - bulletOffsetLeft)
                        }, scrollingPaginationDuration);
                    }

                    if (bulletOffsetLeft + bulletWidth > parentOffsetLeft + parentWidth) {
                        $paginationEl.animate({
                            scrollLeft: scrollLeft + (bulletOffsetLeft + bulletWidth - (parentOffsetLeft + parentWidth))
                        }, scrollingPaginationDuration);
                    }
                }
            }
        }
    }
}